export default {
  main_message: 'See README.md for documentation',
};
